<div class="info-page">
  <h3>Projeto - {{ actionLabel }} </h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Projeto<sup class="text-danger ms-2">*</sup></label>
      <textarea id="title" class="form-control" rows="3" formControlName="title" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição do projeto</label>
      <textarea id="description" class="form-control" rows="3" formControlName="description" [readonly]="!permissions?.edit_not_espec"></textarea>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Justificativa</label>
      <textarea id="ds_reason" class="form-control" rows="3" formControlName="ds_reason" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_reason')" [erros]="fieldErros('ds_reason')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Objetivo do projeto</label>
      <textarea id="ds_goal" class="form-control" rows="3" formControlName="ds_goal" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_goal')" [erros]="fieldErros('ds_goal')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Público-alvo</label>
      <textarea id="ds_target" class="form-control" rows="3" formControlName="ds_target" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_target')" [erros]="fieldErros('ds_target')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Requisitos</label>
      <textarea id="ds_requirements" class="form-control" rows="3" formControlName="ds_requirements" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_requirements')" [erros]="fieldErros('ds_requirements')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Premissas</label>
      <textarea id="ds_assumptions" class="form-control" rows="3" formControlName="ds_assumptions" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_assumptions')" [erros]="fieldErros('ds_assumptions')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Restrições</label>
      <textarea id="ds_restrictions" class="form-control" rows="3" formControlName="ds_restrictions" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_restrictions')" [erros]="fieldErros('ds_restrictions')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Órgão responsável<sup class="text-danger ms-2">*</sup></label>
      <ng-select id="agency" class="ng-select-alternative" [items]="orgaoList" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione o Órgão" formControlName="agency_id" [readonly]="!permissions?.edit_not_espec">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Gerente do Projeto</label>
      <ng-select id="manager_cpf" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione o Gerente" formControlName="manager_cpf" [readonly]="!permissions?.edit_not_espec">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('user_cpf')" [erros]="fieldErros('user_cpf')"></app-field-message>
    </div>
  </div>

  <div formArrayName="manager_adjunct">
    <div class="form-group row m-b" *ngFor="let item of getFormArray().controls; let i = index">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Gerente Adjunto</label>
        <ng-select id="manager" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione o Gerente Adjunto" [formControlName]="i" [readonly]="!permissions?.edit_not_espec">
        </ng-select>
      </div>
      <button class="btn btn-danger col-sm-1 btn-remove" type="button" (click)="removeAdjunctManager(i)" *ngIf="permissions?.save && permissions?.edit_not_espec"><i class="fa fas fa-times"></i></button>
    </div>
  </div>

  <button class="btn btn-success btn-add-item" type="button" (click)="addNewAdjunctManager()" *ngIf="permissions?.save && permissions?.edit_not_espec">Novo Responsável Adjunto</button>


  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Início Previsto<sup class="text-danger ms-2">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_foreseen_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" [readonly]="!permissions?.edit_not_espec">
      <app-field-message [field]="fieldMessageRequired('dt_foreseen_start')" [erros]="fieldErros('dt_foreseen_start')"></app-field-message>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Término Previsto<sup class="text-danger ms-2">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_foreseen_end" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" [readonly]="!permissions?.edit_not_espec">
      <app-field-message [field]="fieldMessageRequired('dt_foreseen_end')" [erros]="fieldErros('dt_foreseen_end')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor Total estimado</label>
      <input id="value" class="form-control text-end" formControlName="value" maxlength="14" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" [readonly]="!permissions?.edit_not_espec" />
      <app-field-message [field]="fieldMessageRequired('value')" [erros]="fieldErros('value')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Fonte de Recurso</label>
      <textarea id="source" class="form-control" rows="3" formControlName="source" [readonly]="!permissions?.edit_not_espec"></textarea>
      <app-field-message [field]="fieldMessageRequired('source')" [erros]="fieldErros('source')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Acompanhamento Orçamentário</label>
      <ng-select id="budget_monitoring" class="ng-select-alternative" [clearable]="false" [items]="values_budget_monitoring" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="budget_monitoring" [readonly]="!permissions?.edit_not_espec"></ng-select>
      <app-field-message [field]="fieldMessageRequired('budget_monitoring')" [erros]="fieldErros('budget_monitoring')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Previsão de execução orçamentária (Liquidação)</label>
      <ng-select id="exec_budget_table_show" class="ng-select-alternative" [clearable]="false" [items]="values_budget_monitoring_exec" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="exec_budget_table_show" [readonly]="!permissions?.edit_not_espec"></ng-select>
      <app-field-message [field]="fieldMessageRequired('exec_budget_table_show')" [erros]="fieldErros('exec_budget_table_show')"></app-field-message>
    </div>
  </div>

  <div *ngIf="idProjeto">
    <div class="info-page">
      <h3>Configurações Específicas </h3>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Ativo</label>
        <ng-select id="actived" class="ng-select-alternative" [clearable]="false" [items]="values_actived" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="actived" [readonly]="!permissions?.edit_actived"></ng-select>
        <app-field-message [field]="fieldMessageRequired('actived')" [erros]="fieldErros('actived')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Estratégico</label>
        <ng-select id="level_priority" class="ng-select-alternative" [clearable]="false" [items]="values_level_monitor" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="level_priority" (change)="changeLevelPriority($event)" [readonly]="!permissions?.edit_level_priority">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('level_priority')" [erros]="fieldErros('level_priority')"></app-field-message>
      </div>
    </div>

    <div *ngIf="tipoGestao != gestaoLocal" class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Assessor de Governança</label>
        <ng-select id="monitor_id" class="ng-select-alternative" [required]="tipoGestao == gestaoIntensiva" [items]="tipoGestao == gestaoIntensiva ? monitor_list : monitor_list_gl" bindLabel="label" bindValue="id" placeholder="Selecione o Assessor" formControlName="monitor_id" [readonly]="!permissions?.edit_not_espec">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('monitor_id')" [erros]="fieldErros('monitor_id')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">
          <span>IRFE </span>
          <i class="pl-1 fa fa-info-circle icon" placement="right" tooltip="{{ irfeProjetoService.LABEL_TOOLTIP }}" placement="bottom"></i>
        </label>
        <ng-select id="irfe_enabled_id" class="ng-select-alternative" [clearable]="false" [items]="values_irfe_enabled" bindLabel="label" bindValue="id" placeholder="" formControlName="irfe_enabled_id" [readonly]="!permissions?.edit_irfe_enabled">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('irfe_enabled_id')" [erros]="fieldErros('irfe_enabled_id')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">
          <span>IRCP </span>
          <i class="pl-1 fa fa-info-circle icon" placement="right" tooltip="{{ ircpProjetoService.LABEL_TOOLTIP }}" placement="bottom"></i>
        </label>
        <ng-select id="ircp_enabled_id" class="ng-select-alternative" [clearable]="false" [items]="values_ircp_enabled" bindLabel="label" bindValue="id" placeholder="" formControlName="ircp_enabled_id" [readonly]="!permissions?.edit_not_espec">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('ircp_enabled_id')" [erros]="fieldErros('ircp_enabled_id')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Status operacional</label>
        <ng-select id="op_status_id" class="ng-select-alternative" [clearable]="false" [items]="values_op_status_id" bindLabel="label" bindValue="id" placeholder="" formControlName="op_status_id" [readonly]="!permissions?.edit_op_status">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('op_status_id')" [erros]="fieldErros('op_status_id')"></app-field-message>
      </div>
    </div>

    <div *ngIf="tipoGestao != gestaoLocal" class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Objetivo do Mapa Estratégico</label>
        <ng-select id="obj_est_id" class="ng-select-alternative" [items]="values_obj_est_id" bindLabel="label" bindValue="id" placeholder="Selecione o Objetivo do Mapa Estratégico" formControlName="obj_est_id" [readonly]="!permissions?.edit_obj_est">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('obj_est_id')" [erros]="fieldErros('obj_est_id')"></app-field-message>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status ok</label>
        <input type="number" class="form-control text-end" formControlName="status_ok" step="1" [readonly]="!permissions?.edit_perc_status">
        <app-field-message [field]="fieldMessageRequired('status_ok')" [erros]="fieldErros('status_ok')"></app-field-message>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status atenção</label>
        <input type="number" class="form-control text-end" formControlName="status_warn" step="1" [readonly]="!permissions?.edit_perc_status">
        <app-field-message [field]="fieldMessageRequired('status_warn')" [erros]="fieldErros('status_warn')"></app-field-message>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status atraso</label>
        <input type="number" class="form-control text-end" formControlName="status_alert" step="1" [readonly]="!permissions?.edit_perc_status">
        <app-field-message [field]="fieldMessageRequired('status_alert')" [erros]="fieldErros('status_alert')"></app-field-message>
      </div>
    </div>

    <div class="form-group row mb-0" formArrayName="program">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Programa/Projeto Agregador</label>
          <div class="row mb-2"  *ngFor="let item of getProgramFormArray().controls; let i = index">
            <div class=" col-10">
              <ng-select id="program" class="ng-select-alternative" [items]="list_pg" bindLabel="label" bindValue="id" 
                  placeholder="Selecione o Programa ou Projeto Agregador" [formControlName]="i" [readonly]="!permissions?.edit_pg">
              </ng-select>
            </div>
            <button class="btn btn-danger col-sm-1 btn-remove mt-0" type="button" (click)="removeProgramManager(i)" *ngIf="permissions?.save && permissions?.edit_pg">
              <i class="fa fas fa-times"></i>
            </button>
          </div>
        <app-field-message [field]="fieldMessageRequired('pg_id')" [erros]="fieldErros('pg_id')"></app-field-message>
      </div>
    </div>
    <button class="btn btn-success btn-add-item" type="button" (click)="addNewProgram()" *ngIf="permissions?.save && permissions?.edit_pg">Novo Programa/Projeto Agregador</button>

    <div class="form-group row m-b">
      <div class="col-sm-10 col-xl-6">
        <label class="col-sm-12 pb-1">Programa/SGO</label>
        <ng-select id="sgo_program" class="ng-select-alternative" [items]="values_sgo_program_id" bindLabel="label" bindValue="id" placeholder="Selecione o Programa/SGO" formControlName="sgo_program" [readonly]="!permissions?.edit_not_espec">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('sgo_program')" [erros]="fieldErros('sgo_program')"></app-field-message>
      </div>
    </div>

  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xs btn-excluir" *ngIf="permissions?.delete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit" *ngIf="permissions?.save">Salvar</button>
    </div>
  </div>
</form>

<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>
